module.exports = __webpack_public_path__ + "static/img/alarmmain.16dc412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarmmain.png
// module id = cw4/
// module chunks = 1